/**
 * Remembers Track's "Group by month" switch: a display option, so it stays as
 * you last left it across tabs, statuses and trips away from Track, rather
 * than resetting per tab. Off until you (or a link carrying ?groupByMonth=)
 * turn it on.
 *
 * Kept in sessionStorage, the same lifetime as lastTrackPath.js: a fresh
 * session starts ungrouped. One value per device rather than per account, as
 * it's the viewer's own display choice, whoever's library they're viewing.
 * Storage can be unavailable (private mode, blocked site data), so every
 * access is guarded.
 */
const STORAGE_KEY = "trackGroupByMonth";

export const getGroupByMonth = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const setGroupByMonth = (value) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Not remembered — the switch still works until Track is left
  }
};
